/* eslint-disable import/no-cycle */
import { useState, useEffect, useContext } from "react";
import { CheckoutContext } from "Root/checkout/CheckoutRoutes";
import getAllIngredients from "../helpers/getAllIngredients";
const useIngredients = () => {
    const [ingredients, setIngredients] = useState({});
    const [name, setName] = useState("");
    const { cart, userCart, setUserName } = useContext(CheckoutContext);
    useEffect(() => {
        userCart.length > 0 &&
            getAllIngredients({
                cart,
                setIngredients,
                setName,
                name,
                setUserName,
            });
    }, [cart, userCart]);
    return { name, ingredients };
};
export default useIngredients;
